import Loader from "@material-ui/core/CircularProgress";
import { Box } from "@material-ui/core";

// Rendering

const SpinnerFullscreen = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Loader color="primary" />
    </Box>
  );
};

export default SpinnerFullscreen;
